export class CreateMasterTemplateDto {

  industries: string[] = [];
  template: string;
  _id: any;

  constructor() {
  }

}
